import {
  createStyles,
  Group,
  Paper,
  Text,
  ThemeIcon,
  Stack,
  SimpleGrid
} from "@mantine/core";
import Utils from "../../../utils/utilities";
import EditableText from "../../../components/editable/EditableText";
import { IconAB, IconOmega, IconReceipt2 } from "@tabler/icons";

const ProjectStats = ({ tokenName, tokenSymbol, tokenPriceInUsd }) => {
  const { classes } = useStyles();

  const data = [
    {
      type: "string",
      title: "Token name",
      formField: tokenName,
      formatterPrefix: null,
      icon: IconAB
    },
    {
      type: "string",
      title: "Token symbol",
      formField: tokenSymbol,
      formatterPrefix: null,
      icon: IconOmega
    },
    {
      type: "number",
      title: "Token price",
      formField: tokenPriceInUsd,
      formatterPrefix: "$",
      icon: IconReceipt2
    }
  ];

  const stats = data.map((stat) => {
    const IconComponent = stat.icon;
    const formField = stat.formField;

    return (
      <Paper withBorder p="md" radius="md" key={stat.title}>
        <Group position="apart" noWrap>
          <div className={classes.editableTextWrapper}>
            <Text
              color="dimmed"
              transform="uppercase"
              weight={700}
              size="xs"
              className={classes.label}
            >
              {stat.title}
            </Text>
            <EditableText
              className={classes.editableText}
              type={stat.type}
              formatted={Utils.formatValueWithPrefix(
                formField?.value,
                stat.formatterPrefix
              )}
              {...formField}
            />
          </div>
          <ThemeIcon
            color="gray"
            variant="light"
            sx={(theme) => ({ color: theme.colors.teal[6] })}
            size={38}
            radius="md"
          >
            <IconComponent size={28} stroke={1.5} />
          </ThemeIcon>
        </Group>
      </Paper>
    );
  });

  return (
    <Stack spacing={10}>
      <Text mb={20}>Token Stats</Text>
      <SimpleGrid cols={3} breakpoints={[{ maxWidth: "sm", cols: 1 }]}>
        {stats}
      </SimpleGrid>
    </Stack>
  );
};

const useStyles = createStyles((theme) => ({
  label: {
    fontFamily: theme.fontFamily
  },
  editableTextWrapper: {
    ".edit-btn": {
      top: 0,
      right: -30,
      width: 22,
      minWidth: 22,
      height: 22,
      minHeight: 22,
      transform: "translateY(25%)",

      ".edit-btn-icon": {
        width: "12px",
        height: "12px"
      }
    }
  },
  editableText: {
    fontSize: 20,
    fontWeight: 700,

    input: {
      fontSize: 20,
      fontWeight: 700
    }
  }
}));

export default ProjectStats;
